import type { FaireProductEntity } from "../../entity_types/product";

export const p_defdw7z8jq: FaireProductEntity = {
  token: "p_defdw7z8jq",
  type: "product",
  name: "Helium 90 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7f453ce8dcedfc493e708e851f96107767fef3d66addbfb0bd95ec50eede67bf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72c594a704e32d25966800d8086c24d735b70c1a4ffb604bc8e07b30777e914f.webp",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:48.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
